import type { PixKeyType as DomainPixKeyType } from '../../../../domain/pix/types';
import type { PixKeyType as UazapiPixKeyType } from '../../../../services/uazapi/outbound';

export interface ChatPixFormInput {
    pixKey: string;
    type: UazapiPixKeyType;
    name?: string;
}

export function toUazapiPixType(type: DomainPixKeyType): UazapiPixKeyType {
    return type.toUpperCase() as UazapiPixKeyType;
}

export function toChatInput(pixKey: string, type: DomainPixKeyType, name: string): ChatPixFormInput {
    return {
        pixKey: pixKey.trim(),
        type: toUazapiPixType(type),
        name: name.trim() || undefined,
    };
}
